import React from 'react';
import axios from 'axios';

import { ReactComponent as CloseIcon } from '../../images/icons/close.svg';
import AppContext from '../app/AppContext';
import SuccessMessage from '../helpers/successMessage';
import ErrorMessage from '../helpers/errorMessage';
import SmallLoader from '../../images/small_loader.gif';
import { isValidEmail } from '../helpers/validationFunctions';

class ContactUs extends React.Component {
    static contextType = AppContext;

    constructor (props) {
        super(props);

        this.state = {
            organisation: '',
            name: '',
            email: '',
            topic: '',
            message: '',
            topics: [],
            readyForSubmission: false,
            isEmailValid: true
        };
    }

    componentDidMount () {
        this.setState({
            organisation: this.context.selectedOrganisation.name,
            name: `${this.context.user.first_name} ${this.context.user.last_name}`,
            email: this.context.user.email,
        });

        const token = this.context.token
            ? this.context.token
            : localStorage.getItem('token');
        const headers = {
            Authorization: `Token ${token}`,
        };

        const apiCallURL = `${process.env.REACT_APP_API_URL}/api/react/lookup/organisation_contact_type/`;

        // Fetch Organisation Sizes
        axios
            .get(apiCallURL, { headers })
            .then(res => res.data)
            .then(({ data }) => {

                this.setState({
                    topics: data,
                    topic: data[0].id
                });
            });

    }

    displaySuccessMessage = message => {
        this.setState({
            currentSuccessMessage: message,
        });
    };

    resetSuccessMessage = () => {
        this.setState({
            currentSuccessMessage: '',
        });
    };

    displayErrorMessage = message => {
        this.setState({
            currentErrorMessage: message,
        });
    };

    resetErrorMessage = () => {
        this.setState({
            currentErrorMessage: '',
        });
    };
    
    createContactUsSelectOptions = () =>
        this.state.topics.map(option => (
            <option key={option.id} value={option.id}>
                {option.name}
            </option>
        ));

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value,
        }, () => {
            const { name, email, organisation, topic, message } = this.state;
            if (name && email && organisation && topic && message && isValidEmail(email)) {
                this.setState({
                    readyForSubmission: true
                });
            }
            else if (email && !isValidEmail(email)) {
                this.setState({
                    isEmailValid: false
                });
            }
            else {
                this.setState({
                    readyForSubmission: false,
                    isEmailValid: true
                });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({
            loadingButton: true
        }, () => {
            const { name, email, organisation, topic, message } = this.state;

            if (!name || !email || !organisation || !topic || !message || !isValidEmail(email)) {
                this.setState({
                    loadingButton: false
                }, () => console.log('some field is empty'));
                return this.displayErrorMessage('There was a problem submitting your query.');
            }

            const token = this.context.token
                ? this.context.token
                : localStorage.getItem('token');
            const headers = {
                Authorization: `Token ${token}`,
            };

            const apiCallURL = `${process.env.REACT_APP_API_URL}/api/react/contact_us/`;

            axios
                .post(apiCallURL, { name, organisation, email, topic, message }, { headers })
                .then(() => {
                    this.setState(
                        {
                            loadingButton: false,
                            readyForSubmission: false,
                        },
                        () => {
                            this.displaySuccessMessage('Thank you for your message, we will contact you as soon as possible.');
                        }
                    );
                    // this.context.toggleContactUsModal();
                })
                .catch(error => {
                    console.log(error);
                    this.setState(
                        {
                            loadingButton: false,
                        },
                        () => {
                            this.displayErrorMessage('There was a problem submitting your query.');
                        }
                    );
                });
        });
    }
    
    render () {
        const { currentSuccessMessage, currentErrorMessage, loadingButton, readyForSubmission, isEmailValid } = this.state;
        return (
            <div className="modal-backdrop">
                {currentSuccessMessage && (
                    <SuccessMessage message={currentSuccessMessage} resetSuccessMessage={this.resetSuccessMessage} />
                )}
                {currentErrorMessage && (
                    <ErrorMessage message={currentErrorMessage} resetErrorMessage={this.resetErrorMessage} />
                )}
                <div className="modal-padding" />
                <div className="modal-container">
                    <div className="modal-header">
                        <button className="modal-close-btn" onClick={() => this.context.toggleContactUsModal()}>
                            <CloseIcon />
                        </button>
                        <h2 className="modal-header-title">Contact us</h2>
                    </div>
                    <div className="modal-scrollable">
                        <div className="modal-content">
                            <div className="modal-content-section">
                                <div className="contact-modal-section">
                                    <p className="modal-section-header">Get support with your Organiser Dashboard</p>
                                    <p className="modal-section-subheader">
                                        Complete the form below and our team will be in contact with 
                                        you as soon as possible in order to provide support.
                                    </p>
                                    <form>
                                        <div className="modal-input-row">
                                            <div className="modal-input-group">
                                                <label htmlFor="account-details-first-name" className="modal-input-label">
                                                Organisation/company name{' '}<span className="required-field">*</span>
                                                </label>
                                                <input
                                                    value={this.state.organisation}
                                                    id="organisation-name"
                                                    onChange={this.handleChange}
                                                    className="input modal-input"
                                                    name="organisation"
                                                    type="text"
                                                />
                                            </div>
            
                                        </div>
                                        <div className="modal-input-row">
                                            <div className="modal-input-group">
                                                <label htmlFor="account-details-first-name" className="modal-input-label">
                                                Your full name{' '}<span className="required-field">*</span>
                                                </label>
                                                <input
                                                    value={this.state.name}
                                                    id="organisation-name"
                                                    onChange={this.handleChange}
                                                    className="input modal-input"
                                                    name="name"
                                                    type="text"
                                                />
                                            </div>
            
                                        </div>

                                        <div className="modal-input-row">
                                            <div className="modal-input-group">
                                                <label htmlFor="account-details-first-name" className="modal-input-label">
                                                Email{' '}<span className="required-field">*</span>
                                                </label>
                                                <input
                                                    value={this.state.email}
                                                    id="organisation-name"
                                                    onChange={this.handleChange}
                                                    className="input modal-input"
                                                    name="email"
                                                    type="text"
                                                />
                                                {!isEmailValid && (
                                                    <div className="small-form-error">
                                                        Email incorrect
                                                    </div>
                                                )}
                                            </div>
            
                                        </div>

                                        <div className="modal-input-row">
                                            <div className="modal-input-group">
                                                <label htmlFor="account-details-first-name" className="modal-input-label">
                                                Topic{' '}<span className="required-field">*</span>
                                                </label>
                                                <select
                                                    className="input modal-input-select"
                                                    id="organisation-address"
                                                    name="topic"
                                                    onChange={this.handleChange}
                                                    value={
                                                        this.state.topic
                                                    }
                                                    required
                                                >
                                                    <option value="" disabled>
                                            Select topic
                                                    </option>
                                                    {this.createContactUsSelectOptions()}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="modal-input-row">
                                            <div className="modal-input-group">
                                                <label htmlFor="account-details-first-name" className="modal-input-label">
                                                Message{' '}<span className="required-field">*</span>
                                                </label>
                                                {/* eslint-disable */}
                                                <textarea
                                                    id="organisation-name"
                                                    onChange={this.handleChange}
                                                    className="input modal-input"
                                                    name="message"
                                                    type="text"
                                                    placeholder={'Please provide as much detail about your issue as possible. The more specific you are the more likely we will be able to provide a swift solution!'}
                                                />
                                                {/* eslint-enable */}
                                            </div>
            
                                        </div>
                                        
                                    </form>
                                </div>
                                <div className="modal-btn-row">
                                    {/* <div
                                        role="button"
                                        className={'btn secondary-btn secondary-btn-rounded modal-form-btn'}
                                        onClick={() => this.context.toggleContactUsModal()}
                                    >
                                        Back
                                    </div> */}
                                    {loadingButton ? (
                                        <div
                                            role="button"
                                            className={
                                                'btn sub-fixed-width-btn primary-btn modal-form-btn disabled-primary-btn'
                                            }
                                        >
                                            <img className="subscription-btn-loader" src={SmallLoader} alt="userprofile" />
                                        </div>
                                    ) : (
                                        <div
                                            role="button"
                                            className={`btn sub-fixed-width-btn primary-btn modal-form-btn ${
                                                readyForSubmission ? '' : 'disabled-primary-btn'
                                            }`}
                                            onClick={readyForSubmission && this.handleSubmit}
                                        >
                                            Send message
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-padding" />
            </div>
        );
    }
}

export default ContactUs;